import api from './axiosConfig';

export interface LookupItem {
  id: string;
  name: string;
}

export interface GeneralDefaultSettingData {
  id?: string;
  shiftId?: string;
  workWeekId?: string;
  departmentId?: string;
  attendanceSupervisorId?: string;
  leaveSupervisorId?: string;
  isActive: boolean;
}

export interface GeneralDefaultSettingResponse {
  setting: GeneralDefaultSettingData | null;
  shiftOptions: LookupItem[];
  workWeekOptions: LookupItem[];
  departmentOptions: LookupItem[];
  employeeOptions: LookupItem[];
}

export const generalDefaultSettingApi = {
  get: async (): Promise<GeneralDefaultSettingResponse> => {
    const response = await api.get<GeneralDefaultSettingResponse>('/general-default-settings');
    return response.data;
  },

  save: async (payload: GeneralDefaultSettingData): Promise<void> => {
    await api.post('/general-default-settings', payload);
  },
};
